var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRepeat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.4.2.1-Create-Class-/-Schedule-Dropdown",
    transform: "translate(-558.000000, -361.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cells-/-Small-Image",
    transform: "translate(537.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(15.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4,13.29708 C2.4176,13.29708 -7.90478794e-14,10.87948 -7.90478794e-14,7.89708 C-7.90478794e-14,4.91468 2.4176,2.49708 5.4,2.49708 L9.1836,2.49708",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "6.89708 4.52970994e-14 9.39408 2.497 6.89708 4.9942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2836,2.49708 C14.266,2.49708 16.6836,4.91468 16.6836,7.89708 C16.6836,10.87948 14.266,13.29708 11.2836,13.29708 L7.5,13.29708",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    points: "9.78652 15.79414 7.28952 13.29714 9.78652 10.79994"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRepeat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/repeat.1036eccf.svg";
export { ForwardRef as ReactComponent };